'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';

export default ['$scope', '$uibModalInstance', 'tax', 'TaxService', 'ModalService', '$security', 'StatusService',
    function($scope, $modalInstance, tax, TaxService, ModalService, $security, StatusService) {
        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.editing = editing;
        $scope.isShowEdit = isShowEdit;
        $scope.checkUniqueName = checkUniqueName;

        init();

        // region Function

        function init() {
            $scope.edit = false;
            $scope.uniqueName = true;
            // копирование
            $scope.tax = angular.copy(tax);

            // Определение заголовка модального окна
            if (tax == null || tax.id == null) {
                $scope.title = 'Создание нового налога';
                $scope.edit = true;
            } else {
                $scope.title = `Редактирование налога "${tax.name}"`;
                $scope.edit = true;
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.tax.status) {
                    $scope.tax.status = data._embedded;
                }
            });
        }

        function checkUniqueName(name) {
            if (name != null && name.trim() != '') {
                TaxService.api.exists({
                    filters: (($scope) => {
                        let filters = [];
                        filters.push(`'name' EQ '${scope.tax.name}'`);
                        if ($scope.tax.id) {
                            filters.push(`'id' NE '${scope.tax.id}'`);
                        }
                        return filters;
                    })($scope),
                }, (data) => {
                    $scope.uniqueName = !data._embedded;
                });
            } else {
                $scope.uniqueLogin = true;
            }
        }

        /**
         * Success
         */
        function ok() {
            $modalInstance.close($scope.tax);
        }

        /**
         * Dismiss
         */
        function cancel() {
            $modalInstance.dismiss();
        }

        /**
         * Редактировать
         */
        function editing() {
            $scope.edit = true;
        }

        /**
         * Отображать кнопку редактировать?
         * @returns {boolean|*}
         */
        function isShowEdit() {
            return !$scope.edit && $security.isAllowWrite('/src-categories');
        }

        // endregion
    }];
